﻿$.fn.dxCtrlNoteCommentaire = function custom_dxCtrlNoteCommentaire(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlnotecommentaire dx-ctrl");
        this.createInstance(new cdxCtrlNoteCommentaire(this, option));
    }
    return this;
}

window.cdxCtrlNoteCommentaire = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            if (name == "value") mConstruit()
        }
    }

    if (typeof option.allowClick == "undefined") option.allowClick = true

    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty();

        if (option.value == null || option.value.length == 0) {
            container.html(option.valueVide)
        } else {
            container.html(option.value)
        }

        container.off("click")
        if (option.allowClick) {
            container.addClass("state-hover")
            container.on("click", function (e) {
                if (option.onOpen) option.onOpen()
                //var popContentElement = null
                var opt = {
                    height: "auto",
                    width: "100%",
                    maxWidth:500,
                    showMaximize: false,
                    hideOnOutsideClick: true,
                    title: option.title,
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding-top", "0")
                        //popContentElement = contentElement
                        var dxNote = $("<div class='barlow dxctrlfocus'/>").appendTo(contentElement).dxTextArea({
                            labelMode: "floating",
                            label: option.title,
                            showClearButton: true,
                            minHeight: (parametre.isMobile ? 150 : 250),
                            value: ((option.value == null) ? "" : option.value.replace(/<br\s*\/?>/gi, '\n')),
                            //onContentReady: function (e) {
                            //    if (parametre.isMobile) { e.component.focus() }
                            //    else {
                            //        window.setTimeout(function () { e.component.focus() }, 500)
                            //    }
                            //}
                        }).dxTextArea("instance")
                        var $Div = $("<div style='width:100%;text-align:right;margin-top:20px;'/>").appendTo(contentElement)
                        $("<div style='display:inline-block;'/>").appendTo($Div).dxCtrlButton({
                            text: "Valider",
                            onClick: function (e) {
                                option.value = (!dxNote.option("value") ? "" : dxNote.option("value").replace(/\n/g, '<br>'))
                                if (option.value == null || option.value.length == 0) {
                                    container.html(option.valueVide)
                                } else {
                                    container.html(option.value)
                                }
                                option.onValueChanged({ value: option.value })
                                popup.hide()
                            }
                        })
                    }
                }
                //if (parametre.isMobile) {
                //    opt.position = {
                //        my: "center top",
                //        at: "center top",
                //        of: window,
                //        offset: "0 50" // ou { x: 0, y: 50 }
                //    }
                //    opt.animation = null
                //    opt.deferRendering = false
                //}
                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase(opt).dxCtrlPopupBase("instance")
                popup.show()
            })
        }

        container.css("height", "")
    }

    mConstruit();
}